import { useState } from "react";
import css from "./Pictures.module.css";

const Pictures = (props) => {
	const { images } = props.product;
	const length = images.length;
	const [slide, setSlide] = useState(length ? 1 : "");
	const url = length ? `../../../assets/images/image-product-${slide}.jpg` : "";
	const fixed = props.fixed === "fixed" && "fixed";

	const sliderHandler = (event) => {
		const next = event.target.id === "next";
		if (next) {
			setSlide((prev) => (prev === length ? 1 : prev + 1));
		}
		if (!next) setSlide((prev) => (prev === 1 ? length : prev - 1));
	};

	const pictureFocusHandler = (event) => {
		const id = +event.target.closest("div").id + 1;
		setSlide(id);
	};

	const modalHandler = () => {
		props.setModal();
	};

	const picture = (
		<div className={`${css["container__pictures"]} bg-center-cover-nr`}>
			{fixed && (
				<div className={css["modal-close-icon"]}>
					<img src="../../../assets/images/icon-close.svg" alt="" />
				</div>
			)}
			<img src={url} alt="sneakers" onClick={modalHandler} />
			<div className={`${fixed && css.fixed} bg-center-cover-nr`} onClick={sliderHandler}>
				<img src="../../../assets/images/icon-previous.svg" alt="" />
			</div>
			<div className={`${fixed && css.fixed} bg-center-cover-nr`} id="next" onClick={(e) => sliderHandler(e)}>
				<img src="../../../assets/images/icon-next.svg" id="next" alt="" />
			</div>
		</div>
	);

	const gallery = (
		<div className={`${css.gallery} ${fixed && css.fixed}`}>
			{images.map((img, ind) => (
				<div
					key={ind}
					id={ind}
					onClick={(e) => pictureFocusHandler(e)}
					className={ind === slide - 1 ? css.active : ""}
				>
					<img src={img} alt="product" />
				</div>
			))}
		</div>
	);

	return (
		<div className={`${css.container} ${fixed && css.fixed}`}>
			{picture}
			{gallery}
		</div>
	);
};

export default Pictures;
